class ContentCtaResizer extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(() => this.updateTileHeight());
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    window.addEventListener("resize", this.handleResize);
    this.observeTileBodies();
    this.updateTileHeight();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.resizeObserver.disconnect();
  }

  handleResize() {
    this.updateTileHeight();
  }

  observeTileBodies() {
    this.getFollowingTileBodies().forEach(el => this.resizeObserver.observe(el));
  }

  getFollowingTileBodies() {
    const bodies = [];
    const gridContainer = this.closest('.product-grid');

    if (!gridContainer) return bodies;

    // Get the block size to determine how many columns this block spans
    const isLargeBlock = this.querySelector('.content-cta--large') !== null;

    if (isLargeBlock) {
      // For 2x2 blocks: get the next 2 following cards
      let el = this.nextElementSibling;
      for (let i = 0; i < 2 && el; i++) {
        const body = el.querySelector(".card-information");
        if (body) {
          bodies.push(body);
        }
        el = el.nextElementSibling;
      }
    } else {
      // For 1x1 and 1x2 blocks: get cards in the same row
      const currentRect = this.getBoundingClientRect();
      const currentTop = currentRect.top;
      const tolerance = 10; // pixels tolerance for same row detection

      // Get all product items and find those in the same row
      const allProductItems = Array.from(gridContainer.querySelectorAll('.product-item'));

      allProductItems.forEach(item => {
        if (item === this) return; // Skip the current content block

        const itemRect = item.getBoundingClientRect();
        const itemTop = itemRect.top;

        // Check if this item is in the same row (within tolerance)
        if (Math.abs(itemTop - currentTop) <= tolerance) {
          const body = item.querySelector(".card-information");
          if (body) {
            bodies.push(body);
          }
        }
      });
    }

    return bodies;
  }

  updateTileHeight() {
    const maxHeight = this.getFollowingTileBodies().reduce((acc, el) => {
      const height = el.getBoundingClientRect().height;
      return Math.max(acc, height);
    }, 0);

    this.style.setProperty("--tile-body-height", `${Math.ceil(maxHeight)}px`);
  }
}

customElements.define("content-cta-resizer", ContentCtaResizer); 